import { requestFormPost } from '@/common/request';

export interface collectParams {
  pinCardId: string;
}

export interface collectRes {
  ret: string;
  msg: string;
}

//资源广场收藏
export async function collect(params: collectParams): Promise<collectRes> {
  return await requestFormPost('/generic/mac/square/collect', params);
}
